/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Domain_BookingInputs */

const en_search_domain_booking = /** @type {(inputs: Search_Domain_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the campaigns and appointments`)
};

/**
* | output |
* | --- |
* | "the campaigns and appointments" |
*
* @param {Search_Domain_BookingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const search_domain_booking = /** @type {((inputs?: Search_Domain_BookingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Domain_BookingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_search_domain_booking(inputs)
});